module.exports = __webpack_public_path__ + "roboto-blackitalic-webfont.d4b6fa08703519bfa7a8.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/roboto-blackitalic-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto-blackitalic-webfont.ttf
// module chunks = styles